import { Path } from 'slate';
import { withHistory, HistoryEditor } from 'slate-history';

/**
 * Check whether to merge an operation into the previous operation.
 */

const shouldMerge = (op, prev) => {
    if (
        prev &&
        op.type === 'insert_text' &&
        (
            op.text === ' ' ||
            op.text === '\n' ||
            op.text === '**' ||
            op.text === '_' ||
            op.text === '`' ||
            op.text === '- '
        )
    ) {
        return false;
    }

    if (op.type === 'set_selection') {
        return true;
    }

    if (
        op.type === 'insert_node' &&
        op.node?.type === 'paragraph' &&
        op.node?.children[0]?.text === ''
    ) {
        return true;
    }

    if (
        prev &&
        op.type === 'insert_text' &&
        prev.type === 'insert_text' &&
        op.offset === prev.offset + prev.text.length &&
        Path.equals(op.path, prev.path)
    ) {
        return true
    }

    if (
        prev &&
        op.type === 'remove_text' &&
        prev.type === 'remove_text' &&
        op.offset + op.text.length === prev.offset &&
        Path.equals(op.path, prev.path)
    ) {
        return true
    }

    return false
}

/**
 * Check whether an operation needs to be saved to the history.
 */

const shouldSave = (op, prev) => {
    if (op.type === 'set_selection' && op.newProperties == null) {
        return false
    }

    return true
}

/**
 * Check whether an operation should overwrite the previous one.
 */

const shouldOverwrite = (op, prev ) => {
    if (prev && op.type === 'set_selection' && prev.type === 'set_selection') {
        return true
    }

    return false
}

/**
 * Check whether an operation should clear the redos stack.
 */

const shouldClear = op => {
    if (op.type === 'set_selection') {
        return false
    }

    return true
}

export const withCustomHistory = editor => {
    const { apply } = editor;

    editor = withHistory(editor, []);

    const { undo } = editor;

    editor.undo = () => {
        undo();
    }

    editor.apply = (op) => {
        const { operations, history } = editor
        const { undos } = history
        const lastBatch = undos[undos.length - 1]
        const lastOp = lastBatch && lastBatch[lastBatch.length - 1]
        const overwrite = shouldOverwrite(op, lastOp)
        let save = HistoryEditor.isSaving(editor)
        let merge = HistoryEditor.isMerging(editor)

        if (save == null) {
            save = shouldSave(op, lastOp)
        }

        if (save) {
            if (merge == null) {
                if (lastBatch == null) {
                    merge = false
                } else if (operations.length !== 0) {
                    merge = true
                } else {
                    merge = shouldMerge(op, lastOp) || overwrite
                }
            }

            // merge = false;

            if (lastBatch && merge) {
                if (overwrite) {
                    lastBatch.pop()
                }

                lastBatch.push(op)
            } else {
                const batch = [op];
                undos.push(batch);
            }

            while (undos.length > 100) {
                undos.shift()
            }

            if (shouldClear(op)) {
                history.redos = []
            }
        }

        apply(op)
    }

    return editor;
}
